/**
 * Browser storage utilities for form data persistence
 *
 * Provides localStorage helpers for email prefilling and form state.
 */
import { STORAGE_KEYS } from './constants';

/**
 * Retrieve stored email from localStorage
 */
export const getStoredEmail = (): string | null => {
  try {
    if (typeof window !== 'undefined') {
      return localStorage.getItem(STORAGE_KEYS.LAST_USED_EMAIL);
    }
  } catch {
    // localStorage may be unavailable (private browsing, etc.)
  }
  return null;
};

/**
 * Save email to localStorage for future prefilling
 */
export const setStoredEmail = (email: string): void => {
  try {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEYS.LAST_USED_EMAIL, email);
    }
  } catch {
    // localStorage may be unavailable (private browsing, etc.)
  }
};

/**
 * Clear stored email from localStorage
 */
export const clearStoredEmail = (): void => {
  try {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(STORAGE_KEYS.LAST_USED_EMAIL);
    }
  } catch {
    // localStorage may be unavailable (private browsing, etc.)
  }
};
